import HeaderMenuDivide from "../../assets/img/top_menu_dividers_shine_effect.png";
import React, {memo} from "react";
import MenuItemLink from "./MunuItemLink";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
    divide: {
        height: 30,
        maxHeight: 30,
        // whiteSpace: "no-wrap"
    }
})

const HeadMenuItem = ({route, label, last}) => {

    const classes = useStyles()

    return (<li>
        <MenuItemLink exact to={route}>{label}</MenuItemLink>
        {!last && <img alt={""} className={classes.divide} src={HeaderMenuDivide}/>}
    </li>);
}

export default memo(HeadMenuItem)